<template>
    <div class="card card-custom mt-3">
        <div class="card-header card-header-tabs-line" style="min-height: 0;">
            <div class="card-toolbar">
                <ul class="nav nav-tabs nav-bold nav-tabs-line">
                    <li v-for="tab in tabs" :key="tab.id" class="nav-item">
                        <a class="nav-link cursor-pointer px-5 py-5"
                           :class="{'active': tab.id === activeTab}"
                           @click.prevent="changeTab(tab.routeName)"
                        >
                                <span class="nav-icon">
                                    <i :class="tab.icon"/>
                                </span>
                            <span class="nav-text">
                                {{ tab.title }}
                            </span>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
        <div class="card-body">
            <div class="tab-content">
                <div class="tab-pane fade active show" role="tabpanel">
                    <slot/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    props: {
        filters: Object,
        tabInit: {
            type: String,
            default: 'overview'
        }
    },

    data() {
        return {
            activeTab: this.tabInit,
            tabs: [
                {
                    id: 'overview',
                    title: this.__('general.overview'),
                    icon: 'fas fa-columns',
                    routeName: 'orders.statistics.overview'
                },
                {
                    id: 'channels',
                    title: this.__('statistics.sales_channels'),
                    icon: 'fas fa-link',
                    routeName: 'orders.statistics.channels'
                },
                {
                    id: 'stores',
                    title: this.__('statistics.stores'),
                    icon: 'fas fa-building',
                    routeName: 'orders.statistics.stores'
                },
                // {
                //     id: 'products',
                //     title: 'Products sold',
                //     icon: 'fas fa-tshirt',
                // },
            ]
        }
    },

    methods: {
        changeTab(routeName) {
            this.$inertia.visit(this.$route(routeName, {
                filter: JSON.stringify(this.filters)
            }), {
                only: ['statistics', 'initFilters', 'initTab']
            });
        }
    }
}
</script>
